export const Designations = [
    {
        value: 'chiefExecutiveOfficer',
        label: 'Chief Executive Officer'
    },
    {
        value: 'chiefFinancialOfficer',
        label: 'Chief Financial Officer'
    },
    {
        value: 'chiefOperatingOfficer',
        label: 'Chief Operating Officer'
    },
    {
        value: 'chiefLegalOfficer',
        label: 'Chief Legal Officer'
    },
    {
        value: 'generalCounsel',
        label: 'General Counsel'
    },
    {
        value: 'managingMember',
        label: 'Managing Member'
    },
    {
        value: 'member',
        label: 'Member'
    },
    {
        value: 'generalPartner',
        label: 'General Partner'
    },
    {
        value: 'managingPartner',
        label: 'Managing Partner'
    },
    {
        value: 'partner',
        label: 'Partner'
    },
    {
        value: 'president',
        label: 'President'
    },
    {
        value: 'executiveVicePresident',
        label: 'Executive Vice President'
    },
    {
        value: 'vicePresident',
        label: 'Vice President'
    },
    {
        value: 'treasurer',
        label: 'Treasurer'
    },
    {
        value: 'comptroller',
        label: 'Comptroller'
    },
    {
        value: 'managingDirector',
        label: 'Managing Director'
    },
    {
        value: 'chairmanOfTheBoardOfDirectors',
        label: 'Chairman of the Board of Directors'
    }
];
